"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styles_1 = require("@material-ui/core/styles");
const useStyles = (0, styles_1.makeStyles)({
    rowsPerPageTitle: {
        marginRight: '8px'
    },
    rowsPerPage: {
        margin: '30px 0',
        display: 'flex',
        justifyContent: 'left',
        alignItems: 'center'
    }
});
exports.default = useStyles;
//# sourceMappingURL=RowsPerPageStyle.js.map